import React from "react";
import SurveyForm from "../SurveyForm";

function Index({ config }) {
  const items = [
    {
      id: 1,
      name: "Select a survey type",
      options: [
        {
          id: 1,
          label:
            "CSD with Survey Information - Base Fee (Includes Complex Boundary Reinstatement)",
          price: config.useNewFees ? 1130.0 : 850.0,
        },
        {
          id: 2,
          label: "CSD without Survey Information - Base Fee",
          price: config.useNewFees ? 643.0 : 550.0,
        },
        {
          id: 3,
          label: "Simple Boundary Reinstatement CSD",
          price: config.useNewFees ? 143.0 : 105.0,
          defaultPlanTypeId: 2,
        },
      ],
      planTypes: [
        {
          id: 1,
          label: "LT",
          tooltip: "Land Transfer Plan",
          depositQuantity: 1,
          availableToOptions: [1, 2],
        },
        {
          id: 2,
          label: "SO",
          tooltip: "Survey Office Plan",
          depositQuantity: 0,
          availableToOptions: [1, 2, 3],
        },
        {
          id: 3,
          label: "ML",
          tooltip: "Māori Land Plan",
          depositQuantity: 0,
          availableToOptions: [1, 2],
        },
      ],
      maxQuantity: 100,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        return true;
      },
    },
    {
      id: 2,
      name: "Primary Parcels and Lease Parcels",
      price: config.useNewFees ? 138.0 : 100.0,
      maxQuantity: 500,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        if (item.selectedOption === 3) return false;

        return true;
      },
    },
    {
      id: 3,
      name: "Non Primary Parcels (excluding lease parcels)",
      price: config.useNewFees ? 80.0 : 60.0,
      maxQuantity: 500,
      fixedQuantity: (item) => {
        return null;
      },
      isEnabled: (item) => {
        if (item.selectedOption === 3) return false;

        return true;
      },
    },
    {
      id: 4,
      name: "Deposit fee",
      price: config.useNewFees ? 182.0 : 150.0,
      maxQuantity: 100,
      fixedQuantity: (item) => {
        return 1;
      },
      isEnabled: (item) => {
        return false;
      },
    },
  ];

  const model = {
    items: items,
    depositFeesId: 4,
    getDepositFeeQuantity: (option, planType) => {
      if (!option || !planType) return 0;

      return planType.label === "LT" ? 1 : 0;
    },
  };

  return <SurveyForm title="CSD Fee Calculator" data={model} />;
}

export default Index;
